<h1 mat-dialog-title>Preise festlegen ({{ anzahlTiere }} Tiere)</h1>

<div mat-dialog-content>
    <p>Bitte geben Sie den Einkaufspreis Brutto fuer die ausgewaehlten Tiere ein:</p>

    <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Einkaufspreis Brutto (EUR)</mat-label>
        <input matInput type="number" [formControl]="preisCtrl" placeholder="0.00" step="0.01" min="0" />
        <mat-error *ngIf="preisCtrl.hasError('required')">Preis ist erforderlich.</mat-error>
        <mat-error *ngIf="preisCtrl.hasError('min')">Preis muss groesser oder gleich 0 sein.</mat-error>
    </mat-form-field>
</div>

<div class="dialog-actions" mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="preisCtrl.invalid || isLoading">
        <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
        Speichern
    </button>

    <div class="dialog-actions-right">
        <button mat-stroked-button color="warn" (click)="deletePrices()" [disabled]="isLoading">
            <mat-icon>delete</mat-icon>
            Preise loeschen
        </button>

        <button mat-button (click)="close()" [disabled]="isLoading">Abbrechen</button>
    </div>
</div>
